// src/components/Navbar.js
import React, { useState } from 'react';
import { HiMenu, HiX } from 'react-icons/hi';
import { GiSeedling } from 'react-icons/gi';
import Logo from '../assets/logo.png';
import { Link } from 'react-router-dom';

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // Toggle menu visibility
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    return (
        <nav className="flex items-center justify-between p-4 bg-black text-white border-b border-gray-800 relative z-20">
            {/* Logo */}
            <div className="z-30">
                <Link to="/" onClick={() => setIsMenuOpen(false)}>
                    <img src={Logo} alt="Logo" className="w-10 rounded-full" />
                </Link>
            </div>

            {/* Desktop Navigation Links */}
            <div className="hidden md:flex space-x-8 text-lg font-medium">
                <Link to="/docs" onClick={() => setIsMenuOpen(false)} className="hover:text-gray-400 transition-colors">
                    Docs
                </Link>
                <Link to="/about" onClick={() => setIsMenuOpen(false)} className="hover:text-gray-400 transition-colors">
                    About
                </Link>
                <Link to="/contact" onClick={() => setIsMenuOpen(false)} className="hover:text-gray-400 transition-colors">
                    Contact
                </Link>
            </div>

            {/* "Join the Seed" Link for Desktop */}
            <div className="hidden md:flex">
                <Link
                    to="/investor-info"
                    className="flex items-center text-white font-semibold hover:text-green-500 transition-colors"
                >
                    <GiSeedling className="mr-1 text-lg" />
                    Join the Seed
                </Link>
            </div>

            {/* Hamburger Menu Icon for Mobile */}
            <div className="md:hidden absolute top-4 right-4 z-40">
                <button onClick={toggleMenu} className="text-2xl">
                    {isMenuOpen ? <HiX /> : <HiMenu />}
                </button>
            </div>

            {/* Mobile Menu Overlay */}
            {isMenuOpen && (
                <div className="fixed inset-0 bg-black text-white z-30 flex flex-col items-center pt-16">
                    {/* Logo in Mobile Menu */}
                    <div className="flex justify-center mb-8">
                        <Link to="/" onClick={() => setIsMenuOpen(false)}>
                            <img src={Logo} alt="Logo" className="w-16 h-auto" />
                        </Link>
                    </div>

                    {/* Mobile Navigation Links */}
                    <div className="flex flex-col items-center space-y-6">
                        <Link to="/docs" onClick={() => setIsMenuOpen(false)} className="text-lg hover:text-gray-400 transition-colors">
                            Docs
                        </Link>
                        <Link to="/about" onClick={() => setIsMenuOpen(false)} className="text-lg hover:text-gray-400 transition-colors">
                            About
                        </Link>
                        <Link to="/contact" onClick={() => setIsMenuOpen(false)} className="text-lg hover:text-gray-400 transition-colors">
                            Contact
                        </Link>
                    </div>

                    {/* "Join the Seed" Link in Mobile Menu */}
                    <div className="mt-auto pb-8">
                        <Link
                            to="/investor-info"
                            className="flex items-center text-lg font-semibold hover:text-green-500 transition-colors"
                            onClick={() => setIsMenuOpen(false)}
                        >
                            <GiSeedling className="mr-1 text-xl" />
                            Join the Seed
                        </Link>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Navbar;
